'use es6';

import { getAll as getAllProblems } from '../../private/action-problem-solution/actions/rename-dashboard/problem';
import { getProblem } from '../../private/action-problem-solution/common/get-problem';
import { isEnabled } from '../../private/action-problem-solution/common/is-enabled';
export const canRenameDashboard = params => isEnabled(params, getAllProblems);
export const getRenameDashboardProblem = params => getProblem(params, getAllProblems);